import { Game, Home, User, Notification } from "iconsax-reactjs";
import { FaUtensils } from "react-icons/fa6";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { httpReauest } from "../../utils/httpRequest";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [user, setUser] = useState(null);
  const [invites, setInvites] = useState();
  const [pendingTasks, setPendingTasks] = useState([]);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
        fetchFriends(parsedUser._id, parsedUser.token);
        fetchPendingTasks(parsedUser._id, parsedUser.token);
      } catch (e) {
        console.error("Error parsing user from localStorage", e);
        localStorage.removeItem("user");
      }
    }
  }, []);

  const fetchPendingTasks = async (userId, token) => {
    try {
      const res = await httpReauest(
        "GET",
        `/task/pending/${userId}`,
        {},
        { "x-access-token": token }
      );
      setPendingTasks(res.data.data || []);
    } catch (error) {
      console.error("Error fetching pending tasks:", error);
    }
  };

  const fetchFriends = async (userId, token) => {
    try {
      const res2 = await httpReauest(
        "GET",
        `/user/friends/invite/${userId}`,
        {},
        { "x-access-token": token }
      );
      setInvites(res2.data.data || []);
    } catch (error) {
      console.error("Error fetching friends:", error);
    }
  };

  // هندل کردن کلیک روی لینک‌هایی که لاگین می‌خوان
  const handleProtectedClick = (e, options = {}) => {
    const { redirectToLogin = false, redirectPath = "/" } = options;

    if (!user) {
      e.preventDefault();

      // پیام «نیاز به لاگین» برای کاربر مهمان
      toast.warning(t("auth_login_required"));

      // اگر برای پروفایل بود → بفرستیم لاگین
      if (redirectToLogin) {
        navigate(`/login?redirect=${encodeURIComponent(redirectPath)}`);
      }
    }
  };

  const notificationCount =
    (invites?.length || 0) + (pendingTasks?.length || 0);

  return (
    <div>
      {children}
      <div className="fixed bottom-0 left-0 right-0 max-w-[748px] md:mx-auto bg-[var(--secondry)] text-white flex justify-around items-center py-2 rounded-2xl m-2 shadow-lg text-sm z-50">
        {/* Home – همیشه آزاد */}
        <Link
          to="/"
          className={`${
            location.pathname === "/" ? "bg-white text-[var(--secondry)]" : ""
          } flex flex-col items-center rounded-[8px] px-3 py-1 text-center`}
        >
          <Home className="text-lg" />
          <span>{t("nav_home")}</span>
        </Link>

        {/* Restaurant – همیشه آزاد */}
        <Link
          to="/restaurant"
          className={`${
            location.pathname === "/restaurant"
              ? "bg-white text-[var(--secondry)]"
              : ""
          } flex flex-col items-center rounded-[8px] px-3 py-1 text-center`}
        >
          <FaUtensils className="text-lg" />
          <span>{t("nav_order")}</span>
        </Link>

        {/* Game – فقط برای کاربر لاگین‌شده */}
        <Link
          to="/game"
          onClick={(e) =>
            handleProtectedClick(e, {
              redirectToLogin: false,
              redirectPath: "/game",
            })
          }
          className={`${
            location.pathname === "/game"
              ? "bg-white text-[var(--secondry)]"
              : ""
          } flex flex-col items-center rounded-[8px] px-3 py-1 text-center`}
        >
          <Game className="text-lg" />
          <span>{t("nav_game")}</span>
        </Link>

        {/* Notification – فقط برای کاربر لاگین‌شده */}
        <Link
          to="/notification"
          onClick={(e) =>
            handleProtectedClick(e, {
              redirectToLogin: false,
              redirectPath: "/notification",
            })
          }
          className={`${
            location.pathname === "/notification"
              ? "bg-white text-[var(--secondry)]"
              : ""
          } flex flex-col items-center rounded-[8px] relative px-3 py-1 text-center`}
        >
          {notificationCount > 0 && (
            <span className="absolute -top-1 right-2 w-5 h-5 rounded-full flex items-center justify-center bg-red-500 text-white text-xs">
              {notificationCount}
            </span>
          )}
          <Notification className="text-lg" />
          <span>{t("nav_notification")}</span>
        </Link>

        {/* Profile – اگر لاگین نبود → هم پیام، هم ریدایرکت به لاگین */}
        <Link
          to="/profile"
          onClick={(e) =>
            handleProtectedClick(e, {
              redirectToLogin: true,
              redirectPath: "/profile",
            })
          }
          className={`${
            location.pathname === "/profile"
              ? "bg-white text-[var(--secondry)]"
              : ""
          } flex flex-col items-center rounded-[8px] relative px-3 py-1 text-center`}
        >
          <User className="text-lg" />
          <span>{t("nav_profile")}</span>
        </Link>
      </div>
    </div>
  );
};

export default Layout;
